import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import api from "../lib/api";

const ComplianceContext = createContext(null);

export function ComplianceProvider({ children }) {
  const [frameworks, setFrameworks] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadFrameworks = useCallback(async () => {
    try {
      const { data } = await api.get("/compliance/frameworks");
      setFrameworks(data.items || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadFrameworks();
  }, [loadFrameworks]);

  return (
    <ComplianceContext.Provider value={{ frameworks, loading, loadFrameworks }}>
      {children}
    </ComplianceContext.Provider>
  );
}

export function useCompliance() {
  const ctx = useContext(ComplianceContext);
  if (!ctx) throw new Error("useCompliance must be used within ComplianceProvider");
  return ctx;
}

export const FRAMEWORK_COLORS = {
  ISO27001: "#2563EB",
  NIST_CSF: "#0891B2",
  PCI_DSS: "#7C3AED",
  GDPR: "#16A34A",
  SOC2: "#D97706",
};

export const COMPLIANCE_LEVEL_META = {
  fully_implemented: { label: "Fully implemented", variant: "success", weight: 100 },
  partially_implemented: { label: "Partially", variant: "warning", weight: 50 },
  not_implemented: { label: "Not implemented", variant: "critical", weight: 0 },
  not_applicable: { label: "Not applicable", variant: "neutral", weight: null },
};

export const CONTROL_STATUS_META = {
  not_started: { label: "Not started", variant: "neutral" },
  in_progress: { label: "In progress", variant: "info" },
  implemented: { label: "Implemented", variant: "success" },
  needs_review: { label: "Needs review", variant: "warning" },
};

export const PRIORITY_META = {
  critical: { label: "Critical", variant: "critical" },
  high: { label: "High", variant: "warning" },
  medium: { label: "Medium", variant: "warning" },
  low: { label: "Low", variant: "success" },
};
